import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'any',
})
export class ActionStorageService {
  constructor() {}
}
